module.exports = __webpack_public_path__ + "media/images/Sem Título-0158820df3593b15b2e221c80ef13f3f.png";